import { connect, mapProps } from '@formily/react'
import { MinimalTiptapEditor } from '../ui/minimal-tiptap'

export const FormilyRichText = connect(
  MinimalTiptapEditor,
  mapProps((props) => {
    return {
      ...props,
      value: props.value,
    }
  }),
)
